import { NgModule } from '@angular/core';
import { FiToggleSwitchComponent } from './fi-toggle-switch.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
    imports: [CommonModule, FormsModule, MatIconModule, MatRippleModule],
    declarations: [FiToggleSwitchComponent],
    exports: [FiToggleSwitchComponent],
})
export class FiToggleSwitchModule {}
